import { Prompt } from 'api/model';
import FolderList from 'components/folders/FolderList';
import PromptItem from './PromptItem';

type Props = {
  prompts: Prompt[];
  forceExpand?: boolean;
  onSelectPrompt: (id: string) => void;
};

const PromptFolderTree = ({ prompts, forceExpand = false, onSelectPrompt }: Props) => (
  <FolderList
    items={prompts}
    getKey={(prompt) => prompt.id}
    getFolderPath={(prompt) => prompt.folder_path}
    renderItem={(prompt) => <PromptItem prompt={prompt} onSelect={() => onSelectPrompt(prompt.id)} />}
    forceExpand={forceExpand}
  />
);

export default PromptFolderTree;
